import { createCrudService, withUsagesEndpoint } from "@dgs/core";
import { LocationIndexResource, LocationOptionResource, LocationSaveRequest } from "../../../../shared/types/location";

const baseKey = ["locations"];
export const locationService = {
	...createCrudService<LocationIndexResource, LocationOptionResource, LocationSaveRequest, LocationSaveRequest>(
		baseKey,
	),
	...withUsagesEndpoint(baseKey),
};
